import { createAction } from '@reduxjs/toolkit';
import { ITimesheet } from '../../../../dto';
import { ACT_SET, MN_TIMESHEET, TYPE_ELEMENT } from '../../../../common';

export const setTimesheet = createAction<ITimesheet>(
  `${MN_TIMESHEET}/${TYPE_ELEMENT}/${ACT_SET}`,
);
